var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"divBox"},[_c('el-card',{staticClass:"box-card"},[_c('upload-index')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }